export default {
  state: {
    questionToRemove: null,
    sectionId: null,
    modal: null,
    data: {},
  },
  mutations: {
    setQuestionToRemove (state, payload) {
      state.questionToRemove = payload
    },
    setSectionForQuestion (state, payload) {
      state.sectionId = payload
    },
    setModal(state, payload) {
      state.modal = payload.modal
      state.data = payload.data
    },
    clearModal(state) {
      state.modal = null
      state.data = {}
    },
  },
  actions: {
    setSectionId ({commit}, payload) {
      commit ('setSectionForQuestion', payload)
    },
    setQuestionId ({commit}, payload) {
      commit ('setQuestionToRemove', payload)
    },
    showModal({commit}, payload) {
      commit('setModal', payload)
    },
    closeModal({commit}, event) {
      if (event === true || event.target.id === 'modal')
        commit('clearModal')
    },
  },
  getters: {
    getSectionId: state => {
      return state.sectionId
    },
    getQuestionToRemove: state => {
      return state.questionToRemove
    },
    getModal: state => {
      return state.modal
    },
    getModalData: state => {
      return state.data
    },
  }
}